/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoWhiteListRemoveRequest model module.
 * @module model/CampaignControllerDtoWhiteListRemoveRequest
 * @version 1.0
 */
class CampaignControllerDtoWhiteListRemoveRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoWhiteListRemoveRequest</code>.
     * @alias module:model/CampaignControllerDtoWhiteListRemoveRequest
     * @param packageName {String} 
     */
    constructor(packageName) { 
        
        CampaignControllerDtoWhiteListRemoveRequest.initialize(this, packageName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, packageName) { 
        obj['packageName'] = packageName;
    }

    /**
     * Constructs a <code>CampaignControllerDtoWhiteListRemoveRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoWhiteListRemoveRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoWhiteListRemoveRequest} The populated <code>CampaignControllerDtoWhiteListRemoveRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoWhiteListRemoveRequest();

            if (data.hasOwnProperty('packageName')) {
                obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoWhiteListRemoveRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoWhiteListRemoveRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CampaignControllerDtoWhiteListRemoveRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['packageName'] && !(typeof data['packageName'] === 'string' || data['packageName'] instanceof String)) {
            throw new Error("Expected the field `packageName` to be a primitive type in the JSON string but got " + data['packageName']);
        }

        return true;
    }


}

CampaignControllerDtoWhiteListRemoveRequest.RequiredProperties = ["packageName"];

/**
 * @member {String} packageName
 */
CampaignControllerDtoWhiteListRemoveRequest.prototype['packageName'] = undefined;






export default CampaignControllerDtoWhiteListRemoveRequest;

